import "./App.css";
import { Routes, Route } from "react-router-dom";
import Homepage from "./Pages/Homepage";
import LetterPage from "./Pages/LetterPage";
import CampPage from "./Pages/CampPage";
import AboutusPage from "./Pages/AboutusPage";
import DonatePage from "./Pages/DonatePage";
import PartnersPage from "./Pages/PartnersPage";
import Applayout from "./layout/Applayout";
import MagazinePage from "./Pages/MagazinePage";
import ArticlePage1 from "./Articlepages/ArticlePage1";
import ArticlePage2 from "./Articlepages/ArticlePage2";

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Applayout />}>
          <Route index element={<Homepage />} />
          <Route path="/letters" element={<LetterPage />} />
          <Route path="/activities" element={<CampPage />} />
          <Route path="/activities/article1" element={<ArticlePage1 />} />
          <Route path="/activities/article2" element={<ArticlePage2 />} />
          <Route path="/aboutus" element={<AboutusPage />} />
          <Route path="/donate" element={<DonatePage />} />
          <Route path="/partners" element={<PartnersPage />} />
          <Route path="/magazine" element={<MagazinePage />} />
        </Route>
      </Routes>
    </div>
  );
}

export default App;
